import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

// Atom family to manage hover state for each node
export const isNodeHoveredAtomFamily = atomFamily(
  (nodeId: string | null | undefined) => {
    if (!nodeId) {
      return atom(false);
    }

    const baseAtom = atom(false);
    baseAtom.debugLabel = `isNodeHoveredAtomFamily(${nodeId})`;
    return baseAtom;
  },
);
